import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ContactAppResource from './ContactAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import UserAppResource from './UserAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';

class ServiceTicketAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Service-Ticket';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/tickets';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'origin',
            'subject',
            'description',
            'reason',
            'comments',
            'dueDate',
            'priority',
            'escalated',
            'closed',
            'closedDate',
            'closedOnCreate',
            'archived',
            'productUuid',
            'userUuid',
            'organizationUuid',
            'workspaceUuid',
            'loanUuid',
            'contactUuid',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
            workspace: WorkspaceAppResource,
            user: UserAppResource,
            contact: ContactAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
            workspace: 'workspace_uuid',
            user: 'user_uuid',
            contact: 'contact_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            origin: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'contactCenter',
                    'webFormOrEmail',
                    'other',
                ],
            },
            subject: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            reason: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            comments: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            dueDate: {
                type: 'string',
                datetime: true,
            },
            priority: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
                inclusion: [
                    'low',
                    'normal',
                    'high',
                ],
            },
            escalated: {
                type: 'string',
            },
            closed: {
                type: 'string',
            },
            closedDate: {
                type: 'string',
                datetime: true,
            },
            closedOnCreate: {
                type: 'string',
            },
            archived: {
                type: 'string',
            },
            userUuid: {
                type: 'string',
                presence: true,
            },
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            workspaceUuid: {
                type: 'string',
            },
            loanUuid: {
                type: 'string',
            },
        };
    }

}

export default ServiceTicketAppResource;
